import { Link } from "react-router-dom";
import type { Article } from "@/types/article";

interface ArticleCardProps {
  article: Article;
  variant?: "vertical" | "horizontal";
}

export default function ArticleCard({ article, variant = "vertical" }: ArticleCardProps) {
  if (variant === "horizontal") {
    return (
      <Link
        to={`/detail/${article.id}`}
        className="group flex gap-4 rounded-lg border border-foreground-200/70 bg-background-50 p-3 transition-colors hover:border-foreground-300"
      >
        <div className="h-24 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} 黑丝搭配示范`}
            title={`${article.title} - 黑丝时尚搭配`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-col justify-center">
          <h4 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
            {article.title}
          </h4>
          <p className="mt-1 line-clamp-2 text-sm text-foreground-600">{article.excerpt}</p>
          <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
            <span>{article.date}</span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" /> {article.popularity}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${article.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-foreground-200/70 bg-background-50 transition-colors hover:border-foreground-300"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 黑丝搭配示范`}
          title={`${article.title} - 黑丝时尚搭配`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 text-xs font-medium text-foreground-800 backdrop-blur">
          {article.season === "spring" && "春"}
          {article.season === "summer" && "夏"}
          {article.season === "autumn" && "秋"}
          {article.season === "winter" && "冬"}
          {" · "}
          {article.tags[0]}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="line-clamp-2 font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.excerpt}</p>
        <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
          <span>{article.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" /> {article.popularity}
          </span>
        </div>
      </div>
    </Link>
  );
}